// Authentication utility functions

export const getCurrentUser = () => {
  const userId = sessionStorage.getItem('userId');
  const userEmail = sessionStorage.getItem('userEmail');
  const userName = sessionStorage.getItem('userName');
  const userRole = sessionStorage.getItem('userRole');
  
  if (!userId) {
    return null;
  }
  
  return {
    id: parseInt(userId),
    email: userEmail,
    name: userName,
    role: userRole
  };
};

export const isCrewAuthenticated = () => {
  return sessionStorage.getItem('crewAuthenticated') === 'true';
};

export const isHouseholdAuthenticated = () => {
  return sessionStorage.getItem('householdAuthenticated') === 'true';
};

export const hasRole = (role) => {
  const userRole = sessionStorage.getItem('userRole');
  return userRole === role;
};

export const hasAnyRole = (roles) => {
  console.log('hasAnyRole called with roles:', roles);
  
  // Try to get user role from JWT authentication first
  try {
    console.log('Attempting to access authService...');
    const authService = require('../services/authService').default;
    console.log('authService loaded:', !!authService);
    
    if (authService.isAuthenticated()) {
      console.log('User is authenticated via authService');
      const user = authService.getUser();
      console.log('User from authService:', user);
      
      if (user && user.role) {
        console.log('User role from authService:', user.role);
        console.log('Searching for roles:', roles);
        const hasRole = roles.includes(user.role);
        console.log('Role check result:', hasRole);
        return hasRole;
      } else if (user && user.roleIds && user.roleIds.length > 0) {
        // Temporary fix: map role IDs to role names
        console.log('No role property, but found roleIds:', user.roleIds);
        const roleIdToName = {
          1: 'Student',
          2: 'Coach', 
          3: 'Staff',
          4: 'Crew',
          5: 'Caregiver',
          6: 'Mentor',
          7: 'Alumni',
          8: 'Support',
          9: 'Inactive',
          10: 'Stakeholder',
          11: 'Team Supervisor'
        };
        
        // Get the primary role (first role ID)
        const primaryRoleId = user.roleIds[0];
        const primaryRole = roleIdToName[primaryRoleId];
        console.log('Primary role from roleIds:', primaryRole);
        
        if (primaryRole) {
          const hasRole = roles.includes(primaryRole.toLowerCase());
          console.log('Role check result from roleIds:', hasRole);
          return hasRole;
        }
      } else {
        console.log('No user or role from authService');
      }
    } else {
      console.log('User is NOT authenticated via authService');
    }
  } catch (error) {
    console.warn('Could not access authService, falling back to sessionStorage:', error);
  }
  
  // Fallback to sessionStorage for backward compatibility
  console.log('Falling back to sessionStorage...');
  const userRole = sessionStorage.getItem('userRole');
  console.log('User role from sessionStorage:', userRole);
  const hasRole = roles.includes(userRole);
  console.log('SessionStorage role check result:', hasRole);
  return hasRole;
};

export const logout = () => {
  sessionStorage.removeItem('crewAuthenticated');
  sessionStorage.removeItem('householdAuthenticated');
  sessionStorage.removeItem('userRole');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('userEmail');
  sessionStorage.removeItem('userName');
  sessionStorage.removeItem('householdId');
}; 